import appCONST from 'constants/app.constants';
import baseEvents from '../modules/base/config/baseEvents';
import gmapButton from '../../images/gmap_button.png';

export default function MapsFactory(
    $timeout,
    $window,
    $rootScope,
    $http,
    $state,
    userService,
    googleMapsService
) {
    'ngInject';

    const regionalSettings = userService && userService.getRegionalSettings();
    const CENTER_MARKER_LABEL_CLASS = 'icon_marker_center';
    const MARKER_LABEL_CLASS = 'icon_marker';
    const markerTemplate = '<span class="content">&nbsp;</span>';
    const priceTemplate = _.template('<span class="content">' + (regionalSettings && regionalSettings.currencySign) + '{{price}}</span>');
    const addressTemplate = _.template(
        '<span class="content">'
        + '<span class="name">{{name}}</span>'
        + '<span class="address">{{address}}</span>'
        + '</span>'
    );

    const markerDefaultOptions = {
        icon: gmapButton,  //empty image is needed to override the default marker icon
        labelAnchor: '1 40',
        labelContent: markerTemplate,
        zIndex: 3,
    };

    return {
        markerOptionsDefaults: {
            icon: gmapButton,
            labelAnchor: '1 40',
            labelContent: markerTemplate,
            labelClass: 'icon_marker',
            zIndex: 3,
        },
        getMarkers,
        addCentralMarker: function(markers, centerLatitude, centerLongitude) {
            const centerMarker = {
                id: 1000000,
                latitude: centerLatitude,
                longitude: centerLongitude,
                options: {
                    icon: gmapButton,
                    labelAnchor: '1 40',
                    labelContent: markerTemplate,
                    labelClass: 'icon_marker_center',
                    zIndex: 3,
                },
            };
            markers.push(centerMarker);
        },
        getMapInitOptions,
        composeMarkers,
        createCityCenterMarker,
        initialize: function($scope) {
            const maps = googleMapsService.getGoogleMaps();
            $scope.clusterOpt = {
                calculator: function(cluster) {
                    return {index: 1, text: cluster.length};
                },
                averageCenter: true,
                maxZoom: 20,
            };

            $scope.$on(baseEvents.TRIGGER_MAP_VISIBILITY, function() {
                $scope.showMap = !$scope.showMap;
            });
            $scope.markersControl = {};

            $scope.$on(baseEvents.MAP_SHOW_HIDE_RATES, function() {
                const markers = $scope.markersControl.getGMarkers();
                const checkClass = markers[0].labelClass;

                markers.forEach(function(marker) {
                    if (marker.get('labelClass') === 'icon_marker_center') {
                        return;
                    }

                    if (['icon_marker', 'icon_address'].indexOf(checkClass) !== -1) {
                        marker.set('labelClass', 'price_marker');
                        marker.set('labelContent', priceTemplate(marker));
                    } else {
                        marker.set('labelClass', 'icon_marker');
                        marker.set('labelContent', markerTemplate);
                    }
                    marker.set('zIndex', 3);
                });
            });

            //center map
            $scope.map = {
                center: {
                    latitude: 0,
                    longitude: 0,
                },
                zoom: 12,
            };

            $scope.options = {
                disableDefaultUI: true,
                panControl: true,
                zoomControl: true,
                mapTypeControl: true,
                mapTypeControlOptions: {
                    style: maps.MapTypeControlStyle.HORIZONTAL_BAR, // eslint-disable-line no-undef
                    position: maps.ControlPosition.LEFT_TOP, // eslint-disable-line no-undef
                },
                panControlOptions: {
                    position: maps.ControlPosition.RIGHT_BOTTOM, // eslint-disable-line no-undef
                },
                zoomControlOptions: {
                    position: maps.ControlPosition.RIGHT_BOTTOM, // eslint-disable-line no-undef
                },
            };

            let tempMarker = null;

            function mouseOverHandler(targetMarker) {
                if (tempMarker === targetMarker.key) {
                    return;
                }
                tempMarker = targetMarker.key;
                const checkZIndex = targetMarker.zIndex;
                if (checkZIndex !== 5) {
                    targetMarker.set('zIndex', 4);
                }

                const checkLabel = targetMarker.labelClass;

                if (checkLabel === 'icon_marker') {
                    $scope.markersControl.getGMarkers().forEach(function(marker) {
                        if (marker.labelClass === 'icon_address') {
                            marker.set('labelClass', 'icon_marker');
                            marker.set('labelContent', markerTemplate);
                        }
                    });
                    targetMarker.set('labelClass', 'icon_address');
                    targetMarker.set('labelContent', addressTemplate(targetMarker));
                } else if (checkLabel === 'icon_address') {
                    targetMarker.set('labelClass', 'icon_marker');
                    targetMarker.set('labelContent', markerTemplate);
                }

                if (checkLabel === 'price_marker') {
                    $scope.markersControl.getGMarkers().forEach(function(marker) {
                        if (marker.labelClass === 'address_marker') {
                            marker.set('labelClass', 'price_marker');
                            marker.set('labelContent', priceTemplate(marker));
                        }
                    });
                    targetMarker.set('labelClass', 'address_marker');
                    targetMarker.set('labelContent', addressTemplate(targetMarker));
                } else if (checkLabel === 'address_marker') {
                    targetMarker.set('labelClass', 'price_marker');
                    targetMarker.set('labelContent', priceTemplate(targetMarker));
                }
            }

            function clickHandler(marker) {
                const state = $state.current.name.split('.')[1];
                $rootScope.$broadcast(state + '-marker-click', marker);
            }

            function mouseOutHandler() {
                $scope.markersControl.getGMarkers().forEach(function(marker) {
                    if (marker.labelClass === 'icon_address') {
                        marker.set('labelClass', 'icon_marker');
                        marker.set('labelContent', markerTemplate);
                    }
                });
                tempMarker = null;
            }

            $scope.markersEvents = {
                click: clickHandler,
                mouseover: mouseOverHandler,
                mouseout: mouseOutHandler,
            };
        },
    };

    function getMapInitOptions(maps) {
        return {
            markersControl: {},
            clasterOpt: {
                calculator: function(cluster) {
                    return {index: 1, text: cluster.length};
                },
                averageCenter: true,
                maxZoom: 20,
            },
            map: {
                center: {
                    latitude: 0,
                    longitude: 0,
                },
                zoom: 12,
            },
            options: {
                disableDefaultUI: true,
                panControl: true,
                zoomControl: true,
                mapTypeControl: true,
                mapTypeControlOptions: {
                    style: maps.MapTypeControlStyle.HORIZONTAL_BAR, // eslint-disable-line no-undef
                    position: maps.ControlPosition.LEFT_TOP, // eslint-disable-line no-undef
                },
                panControlOptions: {
                    position: maps.ControlPosition.RIGHT_BOTTOM, // eslint-disable-line no-undef
                },
                zoomControlOptions: {
                    position: maps.ControlPosition.RIGHT_BOTTOM, // eslint-disable-line no-undef
                },
            },
        };
    }

    function getMarkers(searchId) {
        const params = {
            SearchId: searchId,
            limit: 100,
        };
        const url = `${appCONST.apiUrl}/cars/GetMarkers`;
        return $http.get(url, {params});
    }

    function composeMarkers(markers) {
        return _.map(markers, createMarker);
    }

    function createMarker(marker, index) {
        const {
            Price: price,
            Name: name,
            Address: address,
            Latitude: latitude,
            Longitude: longitude,
        } = marker;

        const newMarker = {
            id: index,
            options: angular.copy(markerDefaultOptions),
            latitude,
            longitude,
        };

        Object.assign(newMarker.options, {
            price,
            name,
            address,
            labelClass: MARKER_LABEL_CLASS,
        });

        return newMarker;
    }

    function createCityCenterMarker(latitude, longitude) {
        const newMarker = {
            id: 1000000,
            coords: {
                latitude,
                longitude,
            },
            options: markerDefaultOptions,
        };
        newMarker.options.labelClass = CENTER_MARKER_LABEL_CLASS;
        return newMarker;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/maps-service.js